import { useId, useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { useTranslation } from 'services/hooks';

import '../style.css'; //derived style from Input
import './style.css';

const AutoCompleteSelect = ({
	label,
	placeholder = label,
	data,
	onChange,
	onSelect,
	onPaste,
	onBlur,
	withoutSelectButton,
	withErrorMessage,
}) => {
	const id = useId();
	const [inputValue, setInputValue] = useState('');
	const buttonRef = useRef();
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'input';

	const _handleOnChange = ({ target }) => {
		const { value } = target;
		onChange(value);
		setInputValue(value);
	};

	const _handleOnSelect = () => {
		if (!selectedId && !withErrorMessage) return;
		onSelect(selectedId);
	};

	const _handleOnPaste = e => {
		onPaste(e);
	};

	const selectedId = useMemo(() => {
		try {
			if (!inputValue) return;
			const selectedElement = data.find(({ description }) => description === inputValue);
			return selectedElement.id;
		} catch (error) {}
		return null;
	}, [data, inputValue]);

	const _handleEnterPress = e => {
		//add Enter as submit
		const { code } = e;
		if (code === 'Enter' || code === 'NumpadEnter') buttonRef.current?.click();
	};

	return (
		<div className="AutoCompleteSelect">
			<div className="AutoCompleteSelect__wrapper">
				<input
					list={id}
					onChange={_handleOnChange}
					placeholder={placeholder}
					value={inputValue}
					onPasteCapture={_handleOnPaste}
					onKeyPress={_handleEnterPress}
					onBlur={onBlur}
				/>
				<datalist id={id}>
					{data?.map(({ description, id }, key) => (
						<option key={key} value={description} option-id={id} />
					))}
				</datalist>
			</div>
			{!withoutSelectButton && (
				<Button
					small
					title={getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_auto_complete_select_button`)}
					onClick={_handleOnSelect}
					ref={buttonRef}
				/>
			)}
		</div>
	);
};
export default AutoCompleteSelect;

AutoCompleteSelect.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			description: PropTypes.string.isRequired,
			id: PropTypes.number.isRequired,
		}).isRequired
	).isRequired,
	label: PropTypes.string,
	placeholder: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onSelect: PropTypes.func,
};
